var map = {
	"./bathroom-sink.png": 526,
	"./bathroom-toilet.png": 527,
	"./beds.png": 528,
	"./dress-hangers.png": 529,
	"./dress-mirror.png": 530,
	"./dress-storage.png": 531,
	"./dress-walkinWardrobe.png": 532,
	"./general-armchair.png": 533,
	"./general-balcony.png": 534,
	"./general-brightness.png": 535,
	"./general-charm.png": 536,
	"./general-coffeeTable.png": 537,
	"./general-decoration.png": 538,
	"./general-garden.png": 539,
	"./general-heating.png": 540,
	"./general-individualHeating.png": 541,
	"./general-lockedRoom.png": 542,
	"./general-loggia.png": 543,
	"./general-noise.png": 544,
	"./general-privateBalcony.png": 545,
	"./general-privateBathroom.png": 546,
	"./general-privateSink.png": 547,
	"./general-privateToilet.png": 548,
	"./general-sofa.png": 549,
	"./general-sofaBed.png": 550,
	"./general-terrace.png": 551,
	"./general-terraceFurniture.png": 552,
	"./general-view.png": 553,
	"./sleep-bedsideLamp.png": 554,
	"./sleep-bedsideTable.png": 555,
	"./sleep-curtains.png": 556,
	"./sleep-duvetAndPillow.png": 557,
	"./sleep-shutters.png": 558,
	"./sleep-veilCurtains.png": 559,
	"./work-bookCase.png": 560,
	"./work-deskAndChair.png": 561,
	"./work-lamp.png": 562,
	"./work-multiSocket.png": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;